import React from 'react';
import Navbar from "../components/Navbar";
import PhotoList from "../components/PhotoList";
import {utilLoopHelper} from "../utils";
import axios from "axios";
import Footer from "../components/Footer";
import {getArtistCookie, pageFilter} from "../data/page_data";
import Loading from "../components/loading";
import CssLoader from '../components/CssLoader';
import LoadingContent from "../components/loading-content";
import TrackVisibility from "react-on-screen";
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

class PhotoPage extends React.Component {
  constructor(props) {
    super(props);
    this.pageData = pageFilter(this.props.artist, '../');
    this.state = {
      page: 4,
      title: "",
      items: [],
    }
  }

  componentDidMount() {
    axios.get('/w/api/' + this.pageData.artist.id + '/photo?x=' + this.pageData.artist.exclusive, {
      headers: {
        PortalAuth: getArtistCookie(this.props.artist)
      }
    })
        .then(response => {
          var respData = response.data;
          this.setState(state => ({items: respData.items}));
        });
    ReactGA.pageview(window.location.pathname + window.location.search);

  }

  nextPage = () => {
    if (this.onload) return;
    this.onload = true;
    setTimeout(() => {
      axios
          .get("/w/api/" + this.pageData.artist.id + "/photo?page=" + this.state.page + '&x=' + this.pageData.artist.exclusive)
          .then((response) => {
            var respData = response.data;
            var newitem = this.state.items.concat(respData.items);
            if (respData.items.length > 0) {
              this.onload = false;
            } else {
              this.finish = true;
            }

            this.setState((state) => ({
              page: this.state.page + 1,
              items: newitem,
            }));

          });
    }, 200);
  };

  render() {
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        <Navbar data={this.pageData} title="PHOTO" />
        {!this.state.items ? (
          <Loading />
        ) : (
          <div className="content photo">
            <div className="berita-populer">
                <div className="container">
                    {this.pageData.artist.floating_url && (
                        <FloatingButton url={this.pageData.artist.floating_url} />
                    )}
                    <ul>
                        {   this.state.items &&
                            utilLoopHelper(this.state.items,
                        (item, index) => {
                          console.log("ITM", item);
                          return <PhotoList key={'ix' + index} data={item}/>
                            }
                            )
                        }
                     </ul>
                </div>
              <TrackVisibility>
                {({ isVisible }) => {
                  if (isVisible) this.nextPage();
                  return this.finish ? <></> : <LoadingContent />;
                }}
              </TrackVisibility>
            </div>
          </div>
        )}
        <Footer />
      </>
    );
  }
}


export default PhotoPage;